export enum ServiceConst {
  CommonService = 'Waste',
} 